import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';

import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordion from '@mui/material/Accordion';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

export const useStyles = makeStyles((theme) => ({
  summaryContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  taskContainer: {
    // minHeight: '52px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    paddingLeft: '0px !important',
  },
  taskCountContainer: {
    width: '35px',
    height: '30px',
    paddingLeft: '0px !important',
  },
  taskCount: {
    borderRadius: '50%',
    marginRight: '3px',
    marginTop: '5px',
    width: '18px',
    height: '18px',
    textAlign: 'center',
    lineHeight: '18px',
    color: '#5dba00',
    background: 'rgba(93, 186, 0, 0.12)',
  },
  taskContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  taskTitle: {
    fontSize: '12px',
    textTransform: 'capitalize',
    // marginRight: theme.spacing(1),
  },
  subTaskDetails: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 'normal',
    color: '#8a8a8a',
    display: 'flex',
  },
  subText: {
    fontSize: '12px',
    textTransform: 'capitalize',
  },
  timeWrapper: {
    display: 'flex',
    width: '45%',
    justifyContent: 'flex-end',
  },
  timeText: {
    // paddingRight: '10px',
    fontSize: '12px',
  },
  trackerHistoryText: {
    fontSize: '12px',
    color: '#666',
    textShadow: '1px 1px 1px #fff',
  },
  deleteIcon: {
    color: 'red',
    fontSize: '20px',
    cursor: 'pointer',
  },
  historyContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  trackerItem: {
    display: 'flex',
    width: '185px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  })
);

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  // '& .MuiAccordionSummary-content': {
  //   marginLeft: theme.spacing(1),
  // },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  // padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));
